import { ChangeDetectorRef, Component, NgZone, OnDestroy } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Subscription, take, timer } from 'rxjs';

export interface GalleryImage {
  src: string;
  thumb: string;
  name: string;
}
@Component({
  selector: 'app-mobileupload',
  standalone: false,
  templateUrl: './mobileupload.component.html',
  styleUrls: ['./mobileupload.component.scss']
})

export class MobileuploadComponent implements OnDestroy {
 constructor(private userInfoService:UserInfoService,public cd: ChangeDetectorRef,private ngZone: NgZone){}
 private failureTimerSub: Subscription | undefined;
  validFiles: File[] = [];
  fileErrors: string[] = [];
  failure:boolean=false;
  submitted:boolean=false;
  uploaded:boolean=false;
  locationname:string='';
  files: File[] = [];
  previewUrls: GalleryImage[] = [];
  readonly maxFileSize = 5 * 1024 * 1024; // 5MB
  readonly allowedTypes = ['image/jpeg', 'image/png'];
   imageFormData = new FormData();
   scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (!input.files) return;

   
  //   this.fileErrors = [];
 
   
  //   //const formData = new FormData();
  //   //formData.append('image', this.validFiles);
  //   //this.previewUrls = Array.from(input.files).map(file => URL.createObjectURL(file) );
  
  //   Array.from(input.files).forEach(file => {
  //     if (!this.allowedTypes.includes(file.type)) {
  //       this.fileErrors.push(`${file.name} is not a JPEG or PNG.`);
  //     } else if (file.size > this.maxFileSize) {
  //       this.fileErrors.push(`${file.name} exceeds 5MB.`);
  //     } else {
  //       this.validFiles.push(file);
  //     /*   const reader = new FileReader(); 
  //       reader.onload = () => { 
  //       this.previewUrls.push(reader.result as string); };
  //       reader.readAsDataURL(file); */

        
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         const image: GalleryImage = { src: e.target.result, thumb: e.target.result, name: file.name };
  //         this.previewUrls.push(image)
  //         this.cd.detectChanges();
  //       }
  //       reader.readAsDataURL(file);
     
  //     }    
  //   });
  // }
  onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (!input.files) return;

  // Keep previously selected valid files and previews.
  // Only clear errors for this selection so the user sees what's wrong now.
  this.fileErrors = [];

  const maxFileSize = this.maxFileSize; // 5MB
  const allowedMime = this.allowedTypes; // ['image/jpeg', 'image/png']
  const allowedExt = ['jpg', 'jpeg', 'png'];

  Array.from(input.files).forEach(file => {
    const name = file.name || '';
    const ext = (name.split('.').pop() || '').toLowerCase();
    const hasValidMime = !!file.type && allowedMime.includes(file.type);
    const hasValidExt = allowedExt.includes(ext);

    if (!hasValidMime || !hasValidExt) {
      this.fileErrors.push(`${name} is not a JPEG or PNG`);
      return;
    }

    if (file.size > maxFileSize) {
      this.fileErrors.push(`${name} exceeds 5MB.`);
      return;
    }

    // Avoid duplicates by name+size
    const exists = this.validFiles.some(f => f.name === file.name && f.size === file.size);
    if (exists) return;


    // Valid file
    this.validFiles.push(file);
    
    // Build preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const image: GalleryImage = { src: e.target.result, thumb: e.target.result, name: file.name };
      this.previewUrls.push(image)
      this.cd.detectChanges();
    }
    reader.readAsDataURL(file);
  });

}
  onUpload() {
    this.submitted=true;
    this.imageFormData.delete;
  this.imageFormData = new FormData();
  const url=window.location.href.split('/');
  const season=url[url.length - 3]
  const qrcode=url[url.length - 4]
  const token=url[url.length - 5]
    
  const locationid=url[url.length - 2]
  
  this.imageFormData.append('locationsId',locationid);
  Array.from(this.validFiles).forEach(upFile=>{
      
    this.imageFormData.append('registration_uploadfile', upFile,upFile.name);
  })
   
  // No valid files to upload
  if (this.validFiles.length === 0) {
    this.fileErrors.push('No valid files to upload.');
    this.failure = true;
    this.uploaded = false;
    this.scrollToTop();
    this.cd.detectChanges();
    return;
  }

  this.userInfoService.mobileupload(this.imageFormData,token,qrcode,season).pipe(take(1)).subscribe({next: (res) => {
        if(res=='SUCCESS'){
          this.uploaded=true;
          this.failure=false;

        }else{
          this.failure = true;
          this.uploaded=false;
        }
        this.scrollToTop();
        this.cd.detectChanges();
      },
      error: () => {
        this.failure = true;
        this.uploaded = false;
        this.scrollToTop();
        this.cd.detectChanges();
      },
    });
}

clearall(){
  this.previewUrls=[];
  this.validFiles=[];
    this.imageFormData.delete;
  this.imageFormData = new FormData();
}
  deleteimage(i:number){
    this.previewUrls.splice(i, 1);
    this.validFiles.splice(i, 1);
  }

ngOnInit(){
    const url=window.location.href.split('/');
    this.locationname=url[url.length-1].replaceAll('%20',' ')
    /* setTimeout(() => { 
      this.failure = true;
      this.uploaded=false; },
       300000);  */
       
  this.failureTimerSub?.unsubscribe();

 const fiveMinutes = 10 * 60 * 1000; // 300000
  this.failureTimerSub = timer(fiveMinutes).subscribe(() => {
    this.ngZone.run(() => {
      this.failure = true;
      this.uploaded = false;
      this.scrollToTop();
      this.cd.detectChanges();
    });
   // If you suspect Zone issues, you can also run inside NgZone.run
  });

  this.cd.detectChanges();
}
  
  ngOnDestroy(): void {
    this.failure = true;
    this.uploaded=false;
    this.failureTimerSub?.unsubscribe();
  }
  
}

